export const FieldDataTypes = Object.freeze({
	NUMBER: 1,
	AMOUNT: 2,
	TEXT: 3,
	BOOLEAN: 4,
	DATETIME: 5,
	LONG_TEXT: 6,
	FILE: 7,
	USER: 8,
	APPROVAL_STATUS: 9,
	DOUBLE: 10,
	AUTOGENERATED_UNIQUEIDENTIFIER: 11,
	AUTOGENERATED_NUMBER: 12,
	AUTOGENERATED_DATETIME: 13,
	AUTOGENERATED_BOOLEAN: 14,
	UNIQUE_IDENTIFIER: 15,
	DATE: 17,
});
